<template>
<div class="va-row row wrap">

    <div class="flex sm7 xs12">
        <va-card title="Watched Processes">
            
            <div class="flex xs12 text-right">
              <va-button @click="start_watched()" v-if="!hasDefault">Launch Default Processes</va-button>
            </div>

            <va-data-table :fields="fields" :data="data" :loading="loading" api-mode>

              <template slot="delete" slot-scope="props" class="text-right">
                <va-button small color="danger" @click="stop(props.rowData)" class="">{{ $t('Stop/remove process') }}</va-button>
              </template>

              <template slot="memory" slot-scope="props" class="text-right">
                  <small v-if="props.rowData.monit">{{formatBytes(props.rowData.monit.memory)}}</small>
                  <small v-if="!props.rowData.monit">{{formatBytes(0)}}</small>
              </template>

              <template slot="cpu" slot-scope="props" class="text-right">
                  <small v-if="props.rowData.monit">{{props.rowData.monit.cpu}}%</small>
                  <small v-if="!props.rowData.monit">0%</small>
              </template>

            </va-data-table>

        </va-card>
    </div>

     <div class="flex sm5 xs12">
        <va-card :title="$t('Spawn Process')">

          <loading :active.sync="loading" :is-full-page="false"></loading>

          <form @submit.prevent="create()">
            <div class="row"> 
            <div class="flex xs12">
                <va-select
                  :label="$t('Type')"
                  v-model="type"
                  textBy="description"
                  :options="types"
                  placeholder="Select process scope"
                  required
                />
              </div>               
              <div class="flex sm12 xs12" v-if="this.type.id == 'hashtag'">
                <va-input
                  name = "Hashtag"
                  v-model="text"
                  placeholder="Hashtag"
                  :errorMessages="[hashtag_err]"
                  :error="hashtag_has_err"
                  required
                />
              </div>
              <div class="flex sm12 xs12" v-if="this.type.id == 'mention' || this.type.id == 'account'">
                <va-input
                  name = "Screen Name"
                  v-model="text"
                  placeholder="Screen Name"
                  :errorMessages="[screen_name_err]"
                  :error="screen_name_has_err"
                  required
                />
              </div>
              <div class="flex sm12 xs12" v-if="this.type.id == 'phrase'">
                <va-input
                  name = "Phrase"
                  v-model="text"
                  placeholder="Phrase"
                  :errorMessages="[phrase_err]"
                  :error="phrase_has_err"
                  required

                />
              </div>
              <div class="flex xs12 text-right">
                <va-button v-if="type.hasOwnProperty('id')" type="submit">Spawn Process</va-button>
              </div>
            </div>
          </form>

        </va-card>
    </div>
</div>
</template>
<script>

import Table from '../ui/table/Table'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Loading from 'vue-loading-overlay';
import Validation from '@/mixins/ValidationMixin';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Table,
    Loading
  },
  mixins: [Validation.Validation],
  props: [],
  data () {
    return {
      internal: null,
      loading: false,
      fields: [
        {
          name: 'pm_id',
          title: 'ID',
        },
        {
          name: 'name',
          title: 'Name',
        },
        {
          name: 'pm2_env.status',
          title: 'Status',
        },
        {
          dataClass: '',
          name: '__slot:memory',
          title: 'Memory',
        },
        {
          dataClass: '',
          name: '__slot:cpu',
          title: 'CPU',
        },
        {
          dataClass: 'text-right',
          name: '__slot:delete',
        },
      ],
      types: [
        {
          id: "hashtag",
          description: 'Hashtag',
        },
        {
          id: "account",
          description: 'Account',
        },
        {
          id: "mention",
          description: 'Mention',
        },
        {
          id: "phrase",
          description: 'Phrase',
        },
      ],
      errorMessages:[],
      text:null,
      type:{},
      hasDefault: false
    }
  },

  computed: {
    
    ...mapState({
      data: state => state.processRunner.processes
    }),

    ...Validation.mapValidationKeys([
      "phrase",
      "screen_name",
      "hashtag"
    ]),

   

  },

  methods: {

    ...mapActions({
      fetchProcesses: 'getProcesses',
      launchProcess: 'startProcesses',
      spawnProcess: 'createProcess',
      deleteProcess: 'deleteProcess'
    }),

   /**
    * Fetch list
    * @ref Store[fetchProcesses]
    */
    fetch(){

      this.loading = true;
      this.fetchProcesses().then( response => this.loading = false );

    },

   /**
    * Fetch list
    * @ref Store[spawnProcess]
    */
    create(){

      this.loading = true;
      this.spawnProcess( {type:this.type.id,text:this.text} ).then( response => {
            this.loading = false
      }).catch( exeption => (this.valErr = exeption,this.loading = false ));

    },

   /**
    * Fetch list
    * @ref Store[deleteProcess]
    */
    stop(process_object){

      this.loading = true;
      this.deleteProcess(process_object).then( response => this.fetch());

    },

   /**
    * Fetch list
    * @ref Store[launchProcess]
    */
    start_watched(){

      this.loading = true;
      this.launchProcess().then( resposne => this.fetch() )

    },

   /**
    * Format to human
    */
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

      
  },

  created () {

    this.internal = setInterval(()=>{
      this.fetchProcesses().catch( error => console.log(error) );
    }, 5000);
    
  },

  mounted(){

    this.fetch();
    
  },

  beforeDestroy(){
    clearInterval(this.internal);
  }
}
</script>
<style scoped>
</style>
